import axios from 'axios';
import {typesINPUT} from '../redux/svtypes/inputTypes'

import { SV_SOJ_ORCMOCK_ADDRESS } from '../constants';

const getDinoRecords = () => {
    const headers = {'content-type': 'application/json'};
    let url = `${SV_SOJ_ORCMOCK_ADDRESS}/essearch/dinos`
        
    //let url = "http://localhost:8080/svapi/coreend/control";
    let ob = {'content-type': 'application/json'};
    return axios.get(url, {headers: ob})
}

export const loadDinoAction = async (dispatch) => {
    const response = await getDinoRecords();
    console.log(response);
    if (response) {
        let payload = {
            my_data: response.data
        }
        return dispatch({
            type: "dino-success",
            payload: payload
        });
    } else {
        console.log("Server error");
    }
}

export const loadRadioAction =  (dispatch, radio_data) => {
    console.log('dinoActions recvd radio)data');
     console.log(radio_data) ;
     return dispatch({
        type: "radio-success",
        payload: radio_data
    });
}